import React from 'react';
import Link from 'next/link';

const Breadcrumbs = ({ crumbs, bottomBorder = false }) => {
  return (
    <div className="main-container w-full">
      <div
        className={`lg:justify-start lg:flex-nowrap text-xs text-center lg:text-left flex flex-wrap items-center justify-center w-full py-6 mx-auto text-gray-500 ${
          bottomBorder ? 'border-b border-gray-100' : ''
        }`}
      >
        {crumbs.map((crumb, index) => {
          const { link, copy } = crumb;
          const formatted = link ? (
            <Link href={link} key={`link-${copy}`}>
              <a className="hover:text-blue-500 font-medium text-gray-800 cursor-pointer">{copy}</a>
            </Link>
          ) : (
            <span key={`nonlink-${copy}`}>{copy}</span>
          );

          return index === crumbs.length - 1 ? (
            formatted
          ) : (
            <div key={copy}>
              {formatted}
              <span className="mx-2">&gt;</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Breadcrumbs;
